<template>
  <div>
    <!-- <el-drawer
      class="cust-textwhite"
      title="Notification"
      :visible.sync="isShowNotification"
      :direction="direction"
      :before-close="handleClose"
    >
      <Notification :isShowNotification="isShowNotification" @func="func" />
    </el-drawer> -->
    <div class="w-full pl-6">
      <div class="bg-primary pt-10 pb-2 pr-8 flex items-start justify-between">
        <div>
          <p class="text-white fsize16">Hello, {{ login.name }}!</p>

          <h2 class="text-white text-3xl mt-2 font-semibold">Dashboard</h2>
        </div>
        <NotificationUser />
      </div>
      <div class="top-adjust pb-8 mt-2 dashonly-scroll">
        <div class="">
          <swiper
            :options="swiperOption"
            class="dash-swip related-product-swiper"
          >
            <swiper-slide
              class="cursor-pointer cardequal cust-shadow rounded-12px relative"
            >
              <div class="bg-white rounded-12px">
                <div class="px-6 py-4">
                  <div class="flex items-center">
                    <h2 class="text-dark fsize14 font-bold flex items-center">
                      Project Details
                      <div
                        v-tooltip.top="{
                          content: 'A brief summary of your project.',
                          class: 'toolcust',
                        }"
                      >
                        <feather-icon
                          icon="InfoIcon"
                          class="ml-1 text-grey flex"
                          svgClasses="w-5 h-5"
                        />
                      </div>
                    </h2>
                  </div>

                  <div class="flex justify-between mt-6">
                    <div class="flex">
                      <img
                        :src="showImage(this.selectedProjectDetails.logo)"
                        class="object-contain w-12 h-12 bg-ec rounded-full"
                      />
                      <div class="pl-3 pr-1">
                        <h2 class="text-black fsize16 my-0 font-semibold">
                          {{ this.selectedProject.projectName }}
                        </h2>
                        <p class="col-4f pt-1 mb-0 fsize12 font-semibold">
                          <a :href="WebsiteLink" target="_blank">
                            {{ WebsiteLink }}</a
                          >
                        </p>
                      </div>
                    </div>

                    <!-- <div
                      class="flex justify-center bg-lightgray rounded-full items-center w-10 h-10"
                    >
                      <feather-icon
                        icon="ChevronRightIcon"
                        svgClasses="w-5 h-5"
                        class="text-gray font-semibold flex"
                      />
                    </div> -->
                  </div>

                  <!-- <div class="mt-2">
                    <h2 class="text-black fsize22 my-0 font-semibold">
                      {{ selectedPlan[0].subscription.name }}
                    </h2>
                    <p class="col-4f pt-1 mb-0 fsize12">
                      {{ selectedPlan[0].subscription.description }}
                    </p>
                  </div> -->
                  <div class="flex justify-between mt-16">
                    <div>
                      <small class="text-8f8f8f fsize10 font-semibold"
                        >Status</small
                      >
                      <h2
                        class="text-black text-sm font-semibold mb-0 flex gap-1 items-center"
                      >
                        {{ this.selectedProjectDetails.projectStatus }}
                        <p class="block w-2 h-2 bg-success rounded-full"></p>
                      </h2>
                    </div>
                    <div>
                      <small class="text-8f8f8f fsize10 font-semibold"
                        >Plan</small
                      >
                      <h2 class="text-black text-sm mb-0">
                        {{ this.selectedPlan[0].subscription.name }}
                      </h2>
                    </div>
                  </div>
                </div>
                <div
                  @click="clickBusinessDetails()"
                  class="bg-primary bottom-0 absolute w-full text-center rounded-b-12px flex items-center justify-center p-4"
                >
                  <h2 class="text-white fsize14 font-medium mb-0">
                    Account Settings
                  </h2>
                </div>
              </div>
            </swiper-slide>

            <swiper-slide
              class="cursor-pointer cardequal cust-shadow rounded-12px relative"
            >
              <div class="bg-white rounded-12px">
                <div class="px-6 py-4">
                  <div class="flex items-center justify-between">
                    <h2 class="text-dark fsize14 font-bold flex items-center">
                      My Subscription
                      <feather-icon
                        icon="InfoIcon"
                        class="ml-1 text-grey flex"
                        svgClasses="w-5 h-5"
                      />
                    </h2>
                    <!-- <div
                      class="flex justify-center bg-light-primary rounded-full items-center w-10 h-10"
                    >
                      <feather-icon
                        icon="ChevronRightIcon"
                        svgClasses="w-5 h-5"
                        class="text-primary font-semibold flex"
                      />
                    </div> -->
                  </div>

                  <div class="flex justify-between mt-4">
                    <div>
                      <feather-icon
                        icon="GlobeIcon"
                        class="text-grey flex"
                        svgClasses="w-6 h-6"
                      />
                      <div class="pt-2">
                        <h2 class="text-black fsize16 my-0 font-semibold">
                          {{ selectedPlan[0].subscription.name }}
                        </h2>
                        <p class="col-4f pt-1 mb-0 fsize12 font-semibold">
                          {{ selectedPlan[0].subscription.description }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="flex justify-between mt-6">
                    <div>
                      <small class="text-8f8f8f fsize10 font-semibold"
                        >Start Date</small
                      >
                      <h2
                        class="text-black text-sm font-semibold mb-0 flex gap-1 items-center"
                      >
                        {{ new Date(selectedPlan[0].createdAt).toDateString() }}
                      </h2>
                    </div>
                    <div>
                      <small class="text-8f8f8f fsize10 font-semibold"
                        >Due Date:</small
                      >
                      <h2 class="text-black text-sm font-semibold mb-0">
                        {{ DateOneYear(selectedPlan[0].createdAt) }}
                      </h2>
                    </div>
                  </div>
                </div>
                <div
                  class="bg-primary bottom-0 absolute w-full text-center rounded-b-12px flex items-center justify-center p-4"
                >
                  <h2 class="text-white fsize14 font-medium mb-0">
                    Upgrade Plan
                  </h2>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide
              class="cursor-pointer cardequal relative cust-shadow rounded-12px"
            >
              <div class="bg-white rounded-12px">
                <div class="px-6 py-4">
                  <div class="flex justify-between items-center">
                    <div class="">
                      <h2 class="text-dark fsize14 flex items-center font-bold">
                        Project Resources
                        <!-- <feather-icon
                          icon="InfoIcon"
                          class="ml-1 text-grey flex"
                          svgClasses="w-5 h-5"
                        /> -->
                      </h2>
                    </div>

                    <div class="">
                      <!-- <img
                            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Ecom/dash1.svg"
                            class="object-contain"
                            alt="banh"
                          /> -->
                      <!-- <div
                        class="flex justify-center bg-light-primary rounded-full items-center w-10 h-10"
                      >
                        <feather-icon
                          icon="ChevronRightIcon"
                          svgClasses="w-5 h-5"
                          class="text-primary font-semibold flex"
                        />
                      </div> -->
                    </div>
                  </div>

                  <div
                    class="mt-8 flex gap-2 items-center relative bg-f4f5f6 px-4 py-4 rounded-10px"
                  >
                    <div class="absolute righttop-8px">
                      <!-- <feather-icon
                        icon="InfoIcon"
                        class="ml-1 text-grey flex"
                        svgClasses="w-5 h-5"
                      /> -->
                    </div>
                    <div class="">
                      <img
                        src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/image/watch.png"
                        class="object-contain"
                        alt="banh"
                      />
                    </div>
                    <div class="pl-2">
                      <p class="text-gray mb-0 fsize10 font-semibold">
                        Development Hours
                      </p>
                      <h2
                        class="text-474747 text-lg pt-1 my-0 leadg font-semibold"
                      >
                        {{ this.selectedProjectDetails.manhours }} Hours
                      </h2>
                    </div>
                  </div>

                  <!-- <div
                    class="mt-4 flex gap-2 overflow-hidden items-center relative p-3 rounded-10px"
                    :class="[
                      this.storagePercent >= 90
                        ? 'bg-light-danger'
                        : 'bg-f4f5f6',
                    ]"
                  >
                    <div class="absolute righttop-8px">
                    </div>
                    <div class="dashh">
                    </div>
                    <div class="flex items-center">
                      <circular-count-down-timer
                        :size="circles.size"
                        :mainCircleId="1"
                        :circles="circles"
                      >
                      </circular-count-down-timer>

                      <div class="pl-2">
                        <p class="text-gray mb-0 fsize10 font-semibold">
                          Account Storage
                        </p>
                        <h2
                          class="text-474747 flex items-center fsize12 pt-1 my-0 leadg font-semibold"
                        >
                          {{ formatStorage(usedKB) }}/
                          {{ formatStorage(totalKB) }}
                        </h2>
                      </div>
                    </div>

                    <div v-if="storagePercent >= 90" class="circle1"></div>
                    <div v-if="storagePercent >= 90" class="circle2"></div>
                    <div v-if="storagePercent >= 90" class="circle3"></div>
                  </div> -->
                </div>
                <div
                  @click="handlescope('builder-scope')"
                  class="bg-primary bottom-0 absolute w-full text-center rounded-b-12px flex items-center justify-center p-4"
                >
                  <h2 class="text-white fsize14 font-medium mb-0">
                    Scope New Requirements
                  </h2>
                </div>
              </div>
            </swiper-slide>

            <swiper-slide
              class="cursor-pointer cardequal relative cust-shadow rounded-12px"
            >
              <div class="bg-white rounded-12px">
                <div class="px-6 pt-4">
                  <div class="flex justify-between items-center">
                    <div class="">
                      <h2 class="text-dark fsize14 font-bold flex items-center">
                        Business Profile

                        <div
                          v-tooltip.top="{
                            content:
                              'such as name, address, and contact details on the platform',
                            class: 'toolcust',
                          }"
                        >
                          <feather-icon
                            icon="InfoIcon"
                            class="ml-1 text-grey flex"
                            svgClasses="w-5 h-5"
                          />
                        </div>
                      </h2>
                    </div>
                    <div class="">
                      <!-- <img
                            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Ecom/dash1.svg"
                            class="object-contain"
                            alt="banh"
                          /> -->
                      <div
                        class="flex justify-center bg-light-primary rounded-full items-center w-10 h-10"
                      >
                        <feather-icon
                          icon="ChevronRightIcon"
                          svgClasses="w-5 h-5"
                          class="text-primary font-semibold flex"
                          @click="clickBusinessDetails()"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="mt-6">
                    <h2 class="text-dark fsize18 font-semibold">
                      Complete your<br />
                      business profile
                    </h2>

                    <div class="grid dashh grid-cols-2 mt-12 gap-2">
                      <!-- <div class="bg-f4f5f6 rounded-lg flex items-center p-2">
                        <h2 class="text-dark fsize10 font-semibold w-7/12">
                          Business <br />
                          Details
                        </h2>
                        <div class="w-5/12">
                          <el-progress
                            type="circle"
                            :percentage="Number(this.formPercentage).toFixed(1)"
                            color="rgba(var(--vs-primary), 1)"
                          ></el-progress>
                        </div>
                      </div> -->

                      <div class="flex items-center bg-f4f5f6 py-4 rounded-lg">
                        <div class="pr-2 pl-4">
                          <h2
                            class="text-474747 flex items-center fsize12 pt-1 my-0 leadg font-semibold"
                          >
                            Business <br />Details
                          </h2>
                        </div>

                        <circular-count-down-timer
                          :size="circles.size"
                          :mainCircleId="1"
                          :circles="businessDetails"
                        >
                        </circular-count-down-timer>
                      </div>

                      <div class="flex items-center bg-f4f5f6 py-4 rounded-lg">
                        <div class="pr-2 pl-4">
                          <h2
                            class="text-474747 flex items-center fsize12 pt-1 my-0 leadg font-semibold"
                          >
                            Brand <br />Profile
                          </h2>
                        </div>

                        <circular-count-down-timer
                          :size="circles.size"
                          :mainCircleId="1"
                          :circles="businessDetails"
                        >
                        </circular-count-down-timer>
                      </div>

                      <!-- <div class="bg-f4f5f6 rounded-lg flex items-center p-2">
                        <h2 class="text-dark fsize12 font-semibold w-7/12">
                          Business <br />
                          Details
                        </h2>
                        <div class="w-5/12">
                          <el-progress
                            type="circle"
                            color="rgba(var(--vs-primary), 1)"
                            :percentage="50"
                          ></el-progress>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>

            <swiper-slide
              class="cursor-pointer cardequal cust-shadow rounded-12px"
            >
              <div class="bg-white rounded-12px px-6 py-4 relative h-full">
                <div class="flex justify-between items-center">
                  <div class="">
                    <h2 class="text-dark fsize14 font-bold flex items-center">
                      BR<span class="text-brcolor">AI</span>NED 2.0 is here
                    </h2>
                  </div>
                  <div class="">
                    <!-- <img
                          src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Ecom/dash1.svg"
                          class="object-contain"
                          alt="banh"
                        /> -->
                    <div
                      class="flex justify-center bg-light-primary rounded-full items-center w-10 h-10"
                    >
                      <feather-icon
                        icon="ChevronRightIcon"
                        svgClasses="w-5 h-5"
                        class="text-primary font-semibold flex"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div class="flex justify-center">
                    <img
                      src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/image/frame1.png"
                      class="h-141px w-full object-contain"
                    />
                  </div>
                </div>
                <div
                  class="bg-primary bottom-0 left-0 absolute w-full text-center rounded-b-12px flex items-center justify-center p-4"
                >
                  <h2 class="text-white fsize14 font-medium mb-0">
                    See Feature Updates
                  </h2>
                </div>
              </div>
            </swiper-slide>
          </swiper>

          <DashboardDown />

          <!-- <Chart /> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import CampaignStatus from "@/views/adminPanel/pages/marcom/components/CampaignStatus.vue";
import Notification from "../../layouts/components/Notification.vue";
import ProgressBar from "vuejs-progress-bar";
import DashboardDown from "./components/DashboardDown";
import Chart from "./components/Chart";
import { EventBus } from "@/main";
import NotificationUser from "./NotificationUser";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import moment from "moment";
export default {
  components: {
    CampaignStatus,
    Notification,
    ProgressBar,
    DashboardDown,
    Chart,
    NotificationUser,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      storagePercent: 0,
      formPercentage: 0,
      nonEmptyCount: 0,
      emptyCount: 0,
      progress: 50,
      emptyColorFillGradient: "#ececec",
      size: 50,
      options: {
        text: {
          color: "#FFFFFF",
          shadowEnable: true,
          shadowColor: "#000000",
          fontSize: 14,
          fontFamily: "Helvetica",
          dynamicPosition: false,
          hideText: false,
        },
        progress: {
          color: "#2dbd2d",
          backgroundColor: "#333333",
          inverted: false,
        },
        layout: {
          height: 50,
          width: 50,
          verticalTextAlign: 61,
          horizontalTextAlign: 25,
          zeroOffset: 0,
          strokeWidth: 20,
          progressPadding: 0,
          type: "circle",
        },
      },
      related_items: [
        {
          name: "Template 1",
          image: require("@/assets/images/banh.png"),
          robo: "Ecommerce 1",
        },
      ],
      products: [],
      smsQuantity: [],
      emailQuantity: "",
      notificationQuantity: "",
      whatsAppQuantity: "",
      addons: [],
      brand: "",
      initialName: "",
      iconInitial: "",
      hover: false,
      totalGB: 0,
      usedGB: 0,
      totalKB: 0,
      usedKB: 0,
      isShowNotification: false,
      notificationCount: 0,
      projectData: [],
      WebsiteLink: "",
      swiperOption: {
        slidesPerView: 3.5,
        observer: true,
        observeParents: true,
        spaceBetween: 20,
        breakpoints: {
          1400: {
            slidesPerView: 3.5,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 3.9,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          575: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          425: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      circles: [
        {
          id: "01",
          steps: 10,
          size: 50,
          strokeWidth: 5,
          value: "5",
          valueFontSize: "16",
          strokeColor: "#cd3197",
        },
      ],

      businessDetails: [
        {
          id: "01",
          steps: 10,
          size: 40,
          strokeWidth: 4,
          value: 0,
          valueFontSize: "16",
          strokeColor: "#cd3197",
        },
      ],
    };
  },

  methods: {
    func(params) {
      if (params) {
        // this.notificationCount = params;
      }
    },
    DateOneYear(date) {
      console.log(date, "AnishKhot");
      let currentDate = new Date(date);
      currentDate.setFullYear(currentDate.getFullYear() + 1);
      return currentDate.toDateString();
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    addUsernameAvatar() {
      this.initialName = this.login.name;
      this.iconInitial = this.initialName[0].toUpperCase();
    },
    async getAddOns() {
      let data = await this.$store.dispatch("billing/myAddOns");
      this.addons = data;
      let smsAddons = {};
      let emailAddons = {};
      let notifyAddons = {};
      let whatsappAddons = {};
      for (let i of this.addons) {
        if (i.addOnId.flag == "T_SMS") {
          smsAddons = i;
        }
        if (i.addOnId.flag == "WA") {
          whatsappAddons = i;
        }
        if (i.addOnId.flag == "PN") {
          notifyAddons = i;
        }
        if (i.addOnId.flag == "PT_EMAILS") {
          emailAddons = i;
        }
        if (i.addOnId.flag == "CG") {
          this.totalGB = Number(i.totalQuantity / 1024 / 1024).toFixed(2);
          this.usedGB =
            Number(i.totalQuantity / 1024 / 1024).toFixed(2) -
            Number(i.quantity / 1024 / 1024).toFixed(2);
          // for percent of gb if exceed 90%
          this.totalKB = Number(i.totalQuantity);
          this.usedKB = Number(
            Number(i.totalQuantity) - Number(i.quantity)
          ).toFixed(2);
          this.storagePercent = (100 * this.usedGB) / this.totalGB;
        }
      }
      this.smsQuantity = smsAddons;
      this.notificationQuantity = notifyAddons;
      this.whatsAppQuantity = whatsappAddons;
      this.emailQuantity = emailAddons;
    },
    formatStorage(sizeInKB) {
      sizeInKB = Number(sizeInKB);
      if (sizeInKB < 1024) {
        return sizeInKB.toFixed(2) + " KB";
      } else if (sizeInKB < 1024 * 1024) {
        return (sizeInKB / 1024).toFixed(2) + " MB";
      } else {
        return (sizeInKB / (1024 * 1024)).toFixed(2) + " GB";
      }
    },
    async SetLayout() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };

      await this.$store.dispatch("brandProfile/getBrandProfile", payload);
      this.brand = this.brandProfile;
      if (this.brand.Layout) {
        this.$store.commit("brandProfile/SET_LAYOUT", this.brand.Layout);
      } else {
        this.$store.commit("brandProfile/SET_LAYOUT", {
          id: "01",
          img: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/projects/branding/layouts/1.png",
          layout: [0, 2, 3, 5, 6, 8],
        });
      }
    },

    moduleAccess(name) {
      let access = false;
      this.modulesList.forEach((x) => {
        if (x.name === name) {
          access = x.access_control;
        }
      });
      return access;
    },
    async getProjectDetails() {
      let payload = {
        projectId: this.selectedProject._id,
      };

      let data = await this.$store.dispatch(
        "projectFile/getProjectDetails",
        payload
      );
      this.projectData = data.data.data;
      this.WebsiteLink =
        this.projectData[0].isLiveSwitch === true
          ? this.projectData[0].websiteUrl
          : `https://${this.selectedProject.projectName}.brained.in`;
    },
    async getBrandProfileDetails() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      let getData = await this.$store.dispatch(
        "brandProfile/getBrandProfile",
        payload
      );
      let fieldsData = getData.data;
      let mainData = [];
      mainData = fieldsData.map((x) => ({
        primaryLogo: x.primaryLogo ? x.primaryLogo : "",
        alternateLogo: x.alternateLogo ? x.alternateLogo : "",
        favIcon: x.favIcon ? x.favIcon : "",
        businessCategory: x.businessCategory.name
          ? x.businessCategory.name
          : "",
        primaryFont: x.primaryFont ? x.primaryFont : "",
        secondaryFont: x.secondaryFont ? x.secondaryFont : "",
        primaryColor: x.primaryColor ? x.primaryColor : "",
        secondaryColor: x.secondaryColor ? x.secondaryColor : "",
        tertiaryColor: x.tertiaryColor ? x.tertiaryColor : "",
        successColor: x.successColor ? x.successColor : "",
        warningColor: x.warningColor ? x.warningColor : "",
        dangerColor: x.dangerColor ? x.dangerColor : "",
        mobile: x.contactDetails.mobile ? x.contactDetails.mobile : 0,
        GSTNumber: x.GSTNumber ? x.GSTNumber : "",
        bankDetails: x.bankDetails ? x.bankDetails : "",
        url: x.contactDetails.url ? x.contactDetails.url : "",
        email: x.contactDetails.email ? x.contactDetails.email : "",
        address: x.contactDetails.address ? x.contactDetails.address : "",
        instagram: x.contactDetails.instagram ? x.contactDetails.instagram : "",
        facebook: x.contactDetails.facebook ? x.contactDetails.facebook : "",
        whatsapp: x.contactDetails.whatsapp ? x.contactDetails.whatsapp : "",
        linkedin: x.contactDetails.linkedin ? x.contactDetails.linkedin : "",
        pintrest: x.contactDetails.pintrest ? x.contactDetails.pintrest : "",
        to: x.contactDetails.to ? x.contactDetails.to : "",
        from: x.contactDetails.from ? x.contactDetails.from : "",
        timezone: x.contactDetails.timezone ? x.contactDetails.timezone : "",
      }));
      for (const value in Object.values(mainData[0])) {
        if (
          Object.values(mainData[0])[value] == "" ||
          Object.values(mainData[0])[value] == 0 ||
          Object.values(mainData[0])[value] == undefined
        ) {
          this.emptyCount++;
        }
      }
      this.formPercentage = 100 - (this.emptyCount / 26) * 100;
      this.businessDetails[0].value = parseInt(this.formPercentage).toFixed(2);
    },
    showImage(value) {
      let default_image = require("@/assets/images/card1.png");
      let image_base_url = this.$imageURL;
      return value ? `${image_base_url}/${value}` : default_image;
    },
    clickBusinessDetails() {
      this.$router.push({ name: "branding" });
    },
    async getNotification() {
      let notificationC = 0;
      let notifications = [];

      let payload = {
        readStatus: false,
        projectName: this.selectedProject.projectName,
        todaysFilter: true,
      };
      let { data } = await this.$store.dispatch(
        "getNotify/getAllNotification",
        payload
      );
      this.notificationCount = data.length;
    },
    handlescope(name) {
      this.$router.push({ name: name });
    },
  },
  async mounted() {
    await this.getAddOns();
    await this.getBrandProfileDetails();
    console.log(this.businessDetails[0].value, "percent");
    await this.SetLayout();
    await this.getProjectDetails();
    // await this.func();
    EventBus.$on("TriggerCommentsNotify", this.getNotification);
    EventBus.$on("billingExpiryNotify", this.getNotification);
    await this.getNotification();
  },
  computed: {
    ...mapState("brandProfile", [
      "brandProfile",
      "googleFontFamily",
      "layoutSelected",
    ]),
    ...mapState("modules", ["modulesList"]),
    ...mapState("admin", ["selectedPlan"]),
    ...mapState("admin", ["myAddOns", "login"]),
    ...mapState("user", ["selectedProject"]),
    ...mapState("projectFile", ["selectedProjectDetails"]),
    ...mapState("user", ["latestVersion"]),
    isAdminPanel() {
      if (this.$route.name === "adminView") {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    hover() {
      this.addUsernameAvatar();
    },
  },
};
</script>
<style lang="scss" scoped>
.circles {
  height: 90vmin;
  position: relative;
  width: 90vmin;

  > div {
    animation: growAndFade 3s infinite ease-out;
    background-color: dodgerblue;
    border-radius: 50%;
    height: 100%;
    opacity: 0;
    position: absolute;
    width: 100%;
  }

  .circle1 {
    animation-delay: 1s;
  }
  .circle2 {
    animation-delay: 2s;
  }
  .circle3 {
    animation-delay: 3s;
  }
}

@keyframes growAndFade {
  0% {
    opacity: 0.25;
    transform: scale(0);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}

body {
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  margin: 0;
}
</style>
